module.exports = __webpack_public_path__ + "static/img/summer_jianjiePic.38858ac7.png";